import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export const DHIRAAGU__USER_SA__NAME__COLUMN_ID = "bc1d17ad-b73e-4051-8906-8ecc7b829340" as Uuid;

export const DHIRAAGU__USER_SA__DISPLAY_NAME__COLUMN_ID = "862abb71-1c65-465e-a908-d7131384e382" as Uuid;

export const DHIRAAGU__USER_SA__DOB__COLUMN_ID = "50fe48bd-7b4b-418e-8256-a227e5bd9f18" as Uuid;

export const DHIRAAGU__USER_SA__GENDER__COLUMN_ID = "1c065dd6-9b51-44ad-9b38-933b716a7307" as Uuid;

export const DHIRAAGU__USER_SA__EMAIL__COLUMN_ID = "2f7e550e-dea6-4097-ad5e-a58ddcd1e791" as Uuid;

export const DHIRAAGU__USER_SA__PHONE_NUMBER__COLUMN_ID = "c5b1a66a-8cf3-4fea-b37c-a16a05060c75" as Uuid;

export const DHIRAAGU__USER_SA__STAFF_CODE__COLUMN_ID = "7d13a720-9113-4705-adc1-c1c54a8293bc" as Uuid;

export const DHIRAAGU__USER_SA__VERIFICATION_SUBMITTED_ON__COLUMN_ID = "b5d6e5b5-7828-4e07-8466-c2b427034a37" as Uuid;

export const DHIRAAGU__USER_SA__VERIFICATION_PROCESSED_ON__COLUMN_ID = "fdd9e1cc-b7f6-4d57-a89f-caabe7a959c2" as Uuid;

export const DHIRAAGU__USER_SA__VERIFICATION_PROCESSED_BY__COLUMN_ID = "884c7b67-ffa5-4dab-a8a2-5f4ace563cd6" as Uuid;

export const DHIRAAGU__USER_SA__VERIFICATION_REJECT_REASON__COLUMN_ID = "2b60d37e-beae-4acd-8109-ba9cd4769554" as Uuid;

export const DHIRAAGU__USER_SA__VERIFICATION_INVITED_AT__COLUMN_ID = "89985f57-797d-40ad-8524-1fcd7fd9ae92" as Uuid;

export const DHIRAAGU__USER_SA__VERIFICATION_INVITED_BY__COLUMN_ID = "69b918c5-d5b2-42b5-a652-b86d8ef3308d" as Uuid;

export const DHIRAAGU__USER_SA__PROFILE_IMAGE_URL__COLUMN_ID = "26fcaed3-5ee3-493f-b6bc-bef2ef46e0ce" as Uuid;

export const DHIRAAGU__USER_BUH__NAME__COLUMN_ID = "bee265a7-c363-4f46-8d7f-9d10c9b52a02" as Uuid;

export const DHIRAAGU__USER_BUH__DISPLAY_NAME__COLUMN_ID = "72fea125-0304-4078-8e8d-694a633f92ce" as Uuid;

export const DHIRAAGU__USER_BUH__DOB__COLUMN_ID = "348e0207-ec24-48aa-b270-16e00088a68d" as Uuid;

export const DHIRAAGU__USER_BUH__GENDER__COLUMN_ID = "3f50a80a-d2c7-49f9-88b9-9b0120ac6acd" as Uuid;

export const DHIRAAGU__USER_BUH__EMAIL__COLUMN_ID = "e72601fc-dcab-4be1-957b-927dd0add829" as Uuid;

export const DHIRAAGU__USER_BUH__PHONE_NUMBER__COLUMN_ID = "9826d439-dc26-4097-b7bc-b34ecd38d796" as Uuid;

export const DHIRAAGU__USER_BUH__STAFF_CODE__COLUMN_ID = "bf177ad7-c89e-4b34-bc02-4dd3ef448233" as Uuid;

export const DHIRAAGU__USER_BUH__VERIFICATION_SUBMITTED_ON__COLUMN_ID = "d4360a5b-855e-4c73-ae07-349aa0c65392" as Uuid;

export const DHIRAAGU__USER_BUH__VERIFICATION_PROCESSED_ON__COLUMN_ID = "6d63f599-1cda-453c-bc71-d4a94350b8cd" as Uuid;

export const DHIRAAGU__USER_BUH__VERIFICATION_PROCESSED_BY__COLUMN_ID = "d9a9bf4d-f7ad-40e9-a35f-188126660e18" as Uuid;

export const DHIRAAGU__USER_BUH__VERIFICATION_REJECT_REASON__COLUMN_ID = "ee8e0b76-fcd4-4d58-8b1b-29019bdcc2af" as Uuid;

export const DHIRAAGU__USER_BUH__VERIFICATION_INVITED_AT__COLUMN_ID = "a8086fdb-0671-40d2-97be-696b40024326" as Uuid;

export const DHIRAAGU__USER_BUH__VERIFICATION_INVITED_BY__COLUMN_ID = "71b44cd9-fdf6-47ce-9dea-b2ed4dfbebac" as Uuid;

export const DHIRAAGU__USER_BUH__PROFILE_IMAGE_URL__COLUMN_ID = "9fa37446-fe18-4680-9da0-874d657ee240" as Uuid;

export const DHIRAAGU__USER_RSM__NAME__COLUMN_ID = "9c99d57a-3eff-4c8b-8c17-40b20bcd579a" as Uuid;

export const DHIRAAGU__USER_RSM__DISPLAY_NAME__COLUMN_ID = "3b7854a3-3772-480f-9e8c-50b9fb9d3cdf" as Uuid;

export const DHIRAAGU__USER_RSM__DOB__COLUMN_ID = "e73e659f-8986-4aaf-af9a-e8a6403b811a" as Uuid;

export const DHIRAAGU__USER_RSM__GENDER__COLUMN_ID = "e4bb0bf4-0aed-4e5b-96b4-a1721ce2cdc7" as Uuid;

export const DHIRAAGU__USER_RSM__EMAIL__COLUMN_ID = "79974862-fe7e-4b10-ac28-62ed02456408" as Uuid;

export const DHIRAAGU__USER_RSM__PHONE_NUMBER__COLUMN_ID = "f779a18c-80d0-4f84-9123-51440e71ddd7" as Uuid;

export const DHIRAAGU__USER_RSM__REGIONS__COLUMN_ID = "8ae21db9-5105-4915-917b-795c24a0cfe7" as Uuid;

export const DHIRAAGU__USER_RSM__ROCS__COLUMN_ID = "f1a2b3c4-d5e6-4f7a-8b9c-0d1e2f3a4b5c" as Uuid;

export const DHIRAAGU__USER_RSM__STAFF_CODE__COLUMN_ID = "b5013514-b4ce-4769-ae2e-c71bc101f419" as Uuid;

export const DHIRAAGU__USER_RSM__VERIFICATION_SUBMITTED_ON__COLUMN_ID = "6b38a166-5efb-42c7-ba27-6912e00fa169" as Uuid;

export const DHIRAAGU__USER_RSM__VERIFICATION_PROCESSED_ON__COLUMN_ID = "e8490280-847f-4f0c-bbc4-59a01d7f53e0" as Uuid;

export const DHIRAAGU__USER_RSM__VERIFICATION_PROCESSED_BY__COLUMN_ID = "7a263ac4-14be-4a92-a622-f0aa738fba23" as Uuid;

export const DHIRAAGU__USER_RSM__VERIFICATION_REJECT_REASON__COLUMN_ID = "0273c968-fd37-45a6-8c67-ae02d295ef35" as Uuid;

export const DHIRAAGU__USER_RSM__VERIFICATION_INVITED_AT__COLUMN_ID = "9328279e-5414-4c15-a1fa-f51e46ac0800" as Uuid;

export const DHIRAAGU__USER_RSM__VERIFICATION_INVITED_BY__COLUMN_ID = "1a61844b-f049-47e5-ba03-2a5aeadd2042" as Uuid;

export const DHIRAAGU__USER_RSM__PROFILE_IMAGE_URL__COLUMN_ID = "f24c8a9c-4b88-4163-ae0e-7780ae8d118d" as Uuid;

export const DHIRAAGU__USER_TSM__NAME__COLUMN_ID = "b27367d9-1bcb-4c7f-857a-ab2361e795f3" as Uuid;

export const DHIRAAGU__USER_TSM__DISPLAY_NAME__COLUMN_ID = "af295800-1848-48cf-9b53-aeea78e6f56a" as Uuid;

export const DHIRAAGU__USER_TSM__DOB__COLUMN_ID = "283648b4-856e-4f12-95b6-a7b5da3332ab" as Uuid;

export const DHIRAAGU__USER_TSM__GENDER__COLUMN_ID = "e88747ea-2490-45ef-a965-a227350d32d5" as Uuid;

export const DHIRAAGU__USER_TSM__EMAIL__COLUMN_ID = "9b16e3eb-ad09-414c-ae1c-edc0826258cf" as Uuid;

export const DHIRAAGU__USER_TSM__PHONE_NUMBER__COLUMN_ID = "fdc88a3d-84cf-4781-ad65-c8b5a63bee41" as Uuid;

export const DHIRAAGU__USER_TSM__ATOLLS__COLUMN_ID = "2db093f4-1921-4006-aa80-04778737157d" as Uuid;

export const DHIRAAGU__USER_TSM__REGIONS__COLUMN_ID = "a2b3c4d5-e6f7-4a8b-9c0d-1e2f3a4b5c6d" as Uuid;

export const DHIRAAGU__USER_TSM__STAFF_CODE__COLUMN_ID = "c747bfe2-d00b-4629-8b62-24d0dd6dabc0" as Uuid;

export const DHIRAAGU__USER_TSM__VERIFICATION_SUBMITTED_ON__COLUMN_ID = "29efe02f-540a-4c85-b400-b78620b54b9d" as Uuid;

export const DHIRAAGU__USER_TSM__VERIFICATION_PROCESSED_ON__COLUMN_ID = "58dd39bb-38d5-4a80-aa3a-bd74637fa4d5" as Uuid;

export const DHIRAAGU__USER_TSM__VERIFICATION_PROCESSED_BY__COLUMN_ID = "f46168e1-5321-4fe9-8181-e9530ee91221" as Uuid;

export const DHIRAAGU__USER_TSM__VERIFICATION_REJECT_REASON__COLUMN_ID = "e95028d9-a947-441c-93af-cde3a3fe0943" as Uuid;

export const DHIRAAGU__USER_TSM__VERIFICATION_INVITED_AT__COLUMN_ID = "f924e986-ddbe-46d0-a65f-3cbcaf991d60" as Uuid;

export const DHIRAAGU__USER_TSM__VERIFICATION_INVITED_BY__COLUMN_ID = "c6e424ac-1678-4dc4-a850-1e504a056616" as Uuid;

export const DHIRAAGU__USER_TSM__PROFILE_IMAGE_URL__COLUMN_ID = "27864b6c-0c2a-4f87-8aaf-f11a91b423f0" as Uuid;

export const DHIRAAGU__USER_TL__NAME__COLUMN_ID = "04e5268e-eda0-4642-9479-f863c206d60e" as Uuid;

export const DHIRAAGU__USER_TL__DISPLAY_NAME__COLUMN_ID = "25ad6b3e-179a-4f7f-962e-be5633da5b71" as Uuid;

export const DHIRAAGU__USER_TL__DOB__COLUMN_ID = "481cad01-bd4c-4dfe-8faa-76b3507df2a9" as Uuid;

export const DHIRAAGU__USER_TL__GENDER__COLUMN_ID = "311b4c70-7561-40fc-9b87-cb9a848800d9" as Uuid;

export const DHIRAAGU__USER_TL__EMAIL__COLUMN_ID = "bb6ba652-88fb-42ff-9420-3476fb8e7649" as Uuid;

export const DHIRAAGU__USER_TL__PHONE_NUMBER__COLUMN_ID = "af2d72ac-2e76-4f69-b580-94966dfb6e69" as Uuid;

export const DHIRAAGU__USER_TL__ISLANDS__COLUMN_ID = "9014aee4-5de1-4436-a0d6-6146d028f9f5" as Uuid;

export const DHIRAAGU__USER_TL__ROCS__COLUMN_ID = "0cc95cc1-69c2-4b9a-8089-fe10684a2635" as Uuid;

export const DHIRAAGU__USER_TL__VIRTUAL_SHOWROOMS__COLUMN_ID = "f6a2f3c3-b381-4f58-9188-916baa8ecec8" as Uuid;

export const DHIRAAGU__USER_TL__STAFF_CODE__COLUMN_ID = "b334cdc1-cfcf-4d47-bb8e-6b95689ae351" as Uuid;

export const DHIRAAGU__USER_TL__VERIFICATION_SUBMITTED_ON__COLUMN_ID = "9f4a76de-cd5b-4008-98ae-1c95dc270257" as Uuid;

export const DHIRAAGU__USER_TL__VERIFICATION_PROCESSED_ON__COLUMN_ID = "ef592cc1-5e2f-4a08-8c9b-6a75b0fce6e3" as Uuid;

export const DHIRAAGU__USER_TL__VERIFICATION_PROCESSED_BY__COLUMN_ID = "6a57e572-7dab-4830-bc37-34dd525491df" as Uuid;

export const DHIRAAGU__USER_TL__VERIFICATION_REJECT_REASON__COLUMN_ID = "06b4dd86-79b2-4045-bd6d-2d916bc433cb" as Uuid;

export const DHIRAAGU__USER_TL__VERIFICATION_INVITED_AT__COLUMN_ID = "4991f669-6988-4bc8-b733-91f600855218" as Uuid;

export const DHIRAAGU__USER_TL__VERIFICATION_INVITED_BY__COLUMN_ID = "293bb4ef-51e7-4324-a61d-1528d84970bd" as Uuid;

export const DHIRAAGU__USER_TL__PROFILE_IMAGE_URL__COLUMN_ID = "61514e8d-5414-45aa-be47-4a42026efe26" as Uuid;

export const DHIRAAGU__USER_SC__NAME__COLUMN_ID = "b1c2d3e4-f5a6-4b7c-8d9e-0f1a2b3c4d5e" as Uuid;

export const DHIRAAGU__USER_SC__DISPLAY_NAME__COLUMN_ID = "5ce1f84e-b049-488b-9cc9-5a0b72f82d6e" as Uuid;

export const DHIRAAGU__USER_SC__DOB__COLUMN_ID = "25cec610-4441-4229-8b29-4ab6a85d6d51" as Uuid;

export const DHIRAAGU__USER_SC__GENDER__COLUMN_ID = "8fd49f76-59bb-45f7-ba57-07280d80b856" as Uuid;

export const DHIRAAGU__USER_SC__EMAIL__COLUMN_ID = "c2d3e4f5-a6b7-4c8d-9e0f-1a2b3c4d5e6f" as Uuid;

export const DHIRAAGU__USER_SC__PHONE_NUMBER__COLUMN_ID = "b76fc55a-d82f-4375-978e-c85c2b70e3ee" as Uuid;

export const DHIRAAGU__USER_SC__ADDRESS__COLUMN_ID = "efa1ec42-397e-427c-9747-99c42a37aa6c" as Uuid;

export const DHIRAAGU__USER_SC__ATOLLS__COLUMN_ID = "8970842c-6b9c-46b9-b0a4-7cd29a9377cf" as Uuid;

export const DHIRAAGU__USER_SC__STAFF_CODE__COLUMN_ID = "1f006d24-dff4-474c-a4e1-c5a724703a8d" as Uuid;

export const DHIRAAGU__USER_SC__VERIFICATION_SUBMITTED_ON__COLUMN_ID = "64556c63-8fc6-40da-aec6-0d9baf774625" as Uuid;

export const DHIRAAGU__USER_SC__VERIFICATION_PROCESSED_ON__COLUMN_ID = "0bd7774f-79e3-4f4b-9c6e-cbef50817564" as Uuid;

export const DHIRAAGU__USER_SC__VERIFICATION_PROCESSED_BY__COLUMN_ID = "365af773-4fd9-4153-b98c-921f123bbb43" as Uuid;

export const DHIRAAGU__USER_SC__VERIFICATION_REJECT_REASON__COLUMN_ID = "31b2145b-15a7-4a55-9fd6-376ad529fe53" as Uuid;

export const DHIRAAGU__USER_SC__VERIFICATION_INVITED_AT__COLUMN_ID = "e5119111-26b7-4cd5-8963-b7376686c26e" as Uuid;

export const DHIRAAGU__USER_SC__VERIFICATION_INVITED_BY__COLUMN_ID = "1288dd73-9290-4592-849e-f426508fa870" as Uuid;

export const DHIRAAGU__USER_SC__PROFILE_IMAGE_URL__COLUMN_ID = "f7517a56-4c6a-42f5-91ed-457b0ed2a0ab" as Uuid;

export const DHIRAAGU__USER_PARTNERS__NAME__COLUMN_ID = "820f2b07-60ef-44d6-8725-86770747707c" as Uuid;

export const DHIRAAGU__USER_PARTNERS__PLATFORM__COLUMN_ID = "8b81d322-5b5a-4e30-83f2-af5efff97ae0" as Uuid;

export const DHIRAAGU__USER_CALLERS__NAME__COLUMN_ID = "91b53ab2-e883-4158-87bc-803dc952be36" as Uuid;

export const DHIRAAGU__USER_CALLERS__EMAIL__COLUMN_ID = "f7c00377-c75b-4e63-82be-7075ccab1aea" as Uuid;

export const DHIRAAGU__USER_CALLERS__PHONE_NUMBER__COLUMN_ID = "8e8d7046-d061-43ee-a00c-0e7a9f2a4ba5" as Uuid;

export const DHIRAAGU__USER_ANALYST__NAME__COLUMN_ID = "ffa31a6d-732e-4be5-8d22-1b161660e490" as Uuid;

export const DHIRAAGU__USER_ANALYST__EMAIL__COLUMN_ID = "ff5eb3c7-364f-4c60-a681-aebe9fb6414f" as Uuid;

export const DHIRAAGU__USER_ANALYST__PHONE_NUMBER__COLUMN_ID = "8564319e-9497-4519-aaa3-083bd59d86d0" as Uuid;

export const DHIRAAGU__USER_ANALYST__ADDRESS__COLUMN_ID = "e1751772-4e7d-4e33-93bf-c1e841bdea93" as Uuid;

export const DHIRAAGU__USER_ANALYST__KYC_DETAILS__COLUMN_ID = "3a60b97a-b1df-4a33-b253-f3cd7ca9ec59" as Uuid;

export const DHIRAAGU__USER_ANALYST1__NAME__COLUMN_ID = "c3d9aa32-c015-4a18-b1e3-c1171e0147cf" as Uuid;

export const DHIRAAGU__USER_ANALYST1__EMAIL__COLUMN_ID = "9b4b002c-2262-4381-97ab-df6b0d439960" as Uuid;

export const DHIRAAGU__USER_ANALYST1__PHONE_NUMBER__COLUMN_ID = "3629ceaf-b071-4f1c-a651-85f4903dff19" as Uuid;

export const DHIRAAGU__USER_ANALYST1__ADDRESS__COLUMN_ID = "c3990f92-ffc6-494f-8f45-9238a46baaf4" as Uuid;

export const DHIRAAGU__USER_ANALYST1__KYC_DETAILS__COLUMN_ID = "d72843d1-edcc-404a-9433-18e6212d9ad4" as Uuid;

export const DHIRAAGU__USER_ANALYST1__ISLANDS__COLUMN_ID = "e2af8e2c-0c40-4c08-8f5c-e613ea6ab101" as Uuid;

export const DHIRAAGU__USER_ANALYST2__NAME__COLUMN_ID = "0887c5c2-843f-4963-a37b-47040806c274" as Uuid;

export const DHIRAAGU__USER_ANALYST2__EMAIL__COLUMN_ID = "86d4b276-d2a7-4fad-9e2f-c5e2084adbc1" as Uuid;

export const DHIRAAGU__USER_ANALYST2__PHONE_NUMBER__COLUMN_ID = "48a403ab-b8b9-45eb-bde7-a2acf93afc8b" as Uuid;

export const DHIRAAGU__USER_ANALYST2__ADDRESS__COLUMN_ID = "41000d92-668a-42ca-bf69-c631f193f4c1" as Uuid;

export const DHIRAAGU__USER_ANALYST2__KYC_DETAILS__COLUMN_ID = "7ef479c7-18d6-4bfa-b710-37a70d35b16b" as Uuid;

export enum DhiraaguRoles {
    "SA" = "230f053e-31f7-4d95-b53b-f13d84d75ed6",
    "BUH" = "02cf3a7f-c8d7-4a32-86cf-9f70ebef5cf5",
    "RSM" = "b3ffd7a9-1b9b-4532-8a88-55f652a4d6a3",
    "TSM" = "94e4808c-df45-4a6f-bf3d-e88bb398005c",
    "TL" = "f2459581-9837-422b-b12c-8214a52000d7",
    "SC" = "a1b2c3d4-e5f6-4a7b-8c9d-0e1f2a3b4c5d",
}

export type DhiraaguUserTemplateColumnIds = {
    displayName: Uuid;
    dob: Uuid;
    gender: Uuid;
    staffCode: Uuid;
    verificationInvitedAt: Uuid;
    verificationInvitedBy: Uuid;
    verificationSubmittedOn: Uuid;
    verificationProcessedOn: Uuid;
    verificationProcessedBy: Uuid;
    verificationRejectReason: Uuid;
    organizationalUnitColumnId: Uuid | null;
    profileImageColumnId: Uuid | null;
};
